const Helper = {
  trace: (data) => {
    console.log(data);
  },

  encodeData: (data) => {
    const payload = [];

    for (const [key, value] of Object.entries(data)) {
      payload.push(encodeURIComponent(key) + "=" + encodeURIComponent(value));
    }

    return payload.join("&");
  },

  getLanguage: () => {
    // get html element
    const htmlEl = document.querySelector("html");
    let currentLang = "sv-SE";

    // get current lang
    if (htmlEl) {
      currentLang = htmlEl.getAttribute("lang");
    }

    return currentLang;
  },
};

export default Helper;
